import {Normalizer, SnapshotEntity} from "../types";

// 'bankahesap' normalizer'i — DosyaBorcluBankaBilgileriCevap
// (uyap/DosyaBorcluBankaBilgileri.ts) girdisini SnapshotEntity dizisine indirger.
//
// Gercek sekil (parse() DosyaBorcluBankaBilgileri.ts:46-55):
//   cevap.sorguSonucDVO: Array<IBorcluBankaBilgileriSonuc> — sorguSonucu true iken
//     parse() her banka icin banka.logo=[] (byte yukunu siler) ve banka.selected=true
//     set eder. sorguSonucu false ise mock'ta ornek yok; bu dosyada tek mock var,
//     alternatif/yorum satiri mock yok (savunma notu) — sorguSonucDVO'nun o dalda
//     var/yok oldugu bilinmiyor, bu yuzden Array.isArray ile savunmali okunur.
//   Ayrica DosyaBorclu.ts kurum-borclu dalinda parse()'a hic girmeden sentetik
//   {sorguSonucu:false, sorguSonucDVO:[]} objesi atanabiliyor — bu obje de
//   Array.isArray kontrolunden gecer, entities bos doner.
//
// IBorcluBankaBilgileriSonuc: {bankaAdi, eftKodu, logo, logoBulunamadi, selected}
// logo (PNG byte dizisi) KESINLIKLE atlanir (gorev talimati + zaten parse() tarafindan
// [] yapiliyor). selected/logoBulunamadi UYAP sorgu verisi degil / gurultu, attrs'a girmez.
export const bankahesapNormalizer: Normalizer = (cevap) => {
    const bos = {entities: []};

    if (!cevap || typeof cevap !== "object") {
        return bos;
    }

    const bankalar = cevap.sorguSonucDVO;
    if (!Array.isArray(bankalar) || bankalar.length === 0) {
        return bos;
    }

    const entities: SnapshotEntity[] = [];
    for (const banka of bankalar) {
        if (!banka || typeof banka !== "object") {
            continue;
        }

        const eftKodu: unknown = banka.eftKodu;
        // eftKodu entity key'idir; olmayan/turu belirsiz kayit atlanir (anahtarsiz entity uretilmez).
        if (eftKodu === undefined || eftKodu === null) {
            continue;
        }
        const key = String(eftKodu);

        const bankaAdi: unknown = banka.bankaAdi;
        const attrs: Record<string, unknown> = {};
        if (typeof bankaAdi === "string" && bankaAdi.length > 0) {
            attrs.bankaAdi = bankaAdi;
        }

        const label = typeof bankaAdi === "string" && bankaAdi.length > 0 ? bankaAdi : key;

        entities.push({key, label, attrs});
    }

    return {
        entities,
        ozet: {bankaSayisi: entities.length}
    };
};
